import { AmbientLight, Color, DirectionalLight } from "three";
var LightsManager = /** @class */ (function () {
    // ----------------------------------------------------------------------------------------------------
    // Construct / Destroy
    //
    function LightsManager() {
        // ------------------------------ Ambient Lights
        this.ambientLights = [];
        this.ambientLights[0] = new AmbientLight(new Color(0xffffff), 0.9);
        // ------------------------------ Directional Lights
        this.directionalLights = [];
        this.directionalLights[0] = new DirectionalLight(new Color(0xffffff), 0.8);
        this.directionalLights[0].position.set(-150, 350, 210);
    }
    LightsManager.prototype.destroy = function () {
    };
    return LightsManager;
}());
export { LightsManager };
